import { useState } from 'react';
// @mui
import toast from 'react-hot-toast';
import { alpha } from '@mui/material/styles';
import { Box, Divider, Typography, MenuItem, Avatar, Stack } from '@mui/material';
import { Link } from 'react-router-dom';
// components
import MenuPopover from '../../../components/MenuPopover';
import { IconButtonAnimate } from '../../../components/animate';
import { dispatch, useSelector } from '../../../redux/store';
import { logout } from '../../../redux/Auth/LoginSlice';
import axiosInstance from '../../../Utilities/axios';

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const [open, setOpen] = useState(null);
  const { User, status } = useSelector((state) => state.Login);

  const tokens = User?.token || localStorage.getItem('useToken');
  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  const handleLogout = () => {
    dispatch(logout());
  };

  const MENU_OPTIONS = [
    {
      label: 'Home',
      linkTo: '/dashboard/dashboard',
    },
    {
      label: 'Profile',
      linkTo: '/dashboard/profile',
    },
    {
      label: 'Change Password',
      linkTo: '/dashboard/changepassword',
    },
    {
      label: 'Connect Stripe',
      action: 'stripe',
      active: status,
    },
  ];

  const handleStripeSetup = async () => {
    try {
      toast.loading('Connecting to Stripe...');

      const response = await axiosInstance.get('/csp/connected/account', {
        headers: { Authorization: `Bearer ${tokens}` },
      });

      toast.dismiss();

      if (response?.data?.onboarding_url) {
        toast.success('Redirecting to Stripe...');
        window.location.href = response.data.onboarding_url; // redirect user
      } else {
        toast.error('Failed to get Stripe link.');
      }
    } catch (error) {
      toast.dismiss();
      toast.error(error.message || 'Something went wrong while connecting to Stripe.');
      console.error('Stripe setup error:', error);
    }
  };
  return (
    <>
      <IconButtonAnimate
        onClick={handleOpen}
        sx={{
          p: 0,
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
            },
          }),
        }}
      >
        <Avatar src={User?.user?.image} alt={User?.user?.name} />
      </IconButtonAnimate>

      <MenuPopover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        sx={{
          p: 0,
          mt: 1.5,
          ml: 0.75,
          '& .MuiMenuItem-root': {
            typography: 'body2',
            borderRadius: 0.75,
          },
        }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle2" noWrap>
            {User?.user?.name}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {User?.user?.email}
          </Typography>
        </Box>

        <Divider sx={{ borderStyle: 'dashed' }} />
        <Stack sx={{ p: 1 }}>
          {MENU_OPTIONS.map((option) => {
            let content = null;

            if (option.linkTo) {
              content = (
                <Link style={{ textDecoration: 'none', color: 'black' }} to={option.linkTo}>
                  {option.label}
                </Link>
              );
            } else if (option.action === 'stripe' && option.active === false) {
              content = (
                <Typography
                  sx={{
                    fontSize: '15px',
                    color: option.active ? 'gray' : 'black',
                    cursor: option.active ? 'not-allowed' : 'pointer',
                  }}
                >
                  {option.label}
                </Typography>
              );
            }

            return (
              <MenuItem
                key={option.label}
                disabled={option.active} // disable if already connected
                onClick={() => {
                  handleClose();

                  // 👇 run API when status is false (Stripe not connected)
                  if (option.action === 'stripe' && !option.active) {
                    handleStripeSetup();
                  }
                }}
              >
                {content}
              </MenuItem>
            );
          })}
        </Stack>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <MenuItem onClick={() => handleLogout()} sx={{ m: 1 }}>
          Logout
        </MenuItem>
      </MenuPopover>
    </>
  );
}
